import { computed, getCurrentInstance } from "@vue/composition-api";

export default function useParamsUserId() {
  const vm = getCurrentInstance();
  const paramsUserId = computed(() => vm?.$route.params.userId || "");
  return { paramsUserId };
}
